import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { Offer } from "@models";
import { FiatDepositModalComponent } from "../../../fiat-transactions/fiat-deposit-modal/fiat-deposit-modal.component";
import { FiatWalletService } from "@main-services/wallet/fiat_wallet.service";
import { FiatTransaction } from "@models/transaction";
import { TRADE_TYPE } from "@models/trade-offer.model";
import { MasterdataService } from "@core-services/masterdata.service";
import { CustomModal } from "@modules/core/components/base-modals";
import { TradeSavingsComponent } from "@modules/trade/modals/trade-savings-modal/trade-savings-modal.component";

@Component({
	selector: "deposit-failed",
	templateUrl: "./deposit-failed.component.html",
	styleUrls: ["../deposit-common-end-screen/deposit-common-end-screen.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class DepositFailedComponent extends CustomModal {
	@Input()
	public fiatTransaction: FiatTransaction = null;

	@Input()
	public isSavings: boolean = false;

	public constructor(
		private fiatWalletService: FiatWalletService,
		private masterDataService: MasterdataService
	) {
		super();
	}

	public changeDepositMethod(): void {
		this.close("changeDepositMethod");
	}

	public tryAgain(): void {
		let fwt = new FiatTransaction();
		fwt.setFiatWalletId(this.fiatTransaction.getFiatWalletId());
		fwt.setPaymentOptionId(this.fiatTransaction.getPaymentOptionId());
		fwt.setFiatId(this.fiatTransaction.getFiatId());
		fwt.setAmount(this.fiatTransaction.getAmount() + this.fiatTransaction.getFee());
		fwt.setFee(this.fiatTransaction.getFee());
		if (!this.isSavings) {
			this.modalService
				.create(FiatDepositModalComponent, { data: { transaction: fwt } })
				.present()
				.afterViewInit.subscribe(async (modalInstance: FiatDepositModalComponent) => {
					modalInstance.selectWallet(this.fiatWalletService.getItemById(fwt.getFiatWalletId()));
					await modalInstance.selectProvider(
						this.masterDataService.getPaymentOptionById(fwt.getPaymentOptionId())
					);
					modalInstance.setAmount(fwt.getAmount());
				});
		} else {
			const offer = new Offer();
			offer.setType(TRADE_TYPE.RECURRING_BUY);
			this.modalService.create(TradeSavingsComponent, { data: offer }).present();
		}
		this.close();
	}
}
